export default __webpack_public_path__ + "static/media/tete92.fad30f18.png";